<div class="max-w-4xl mx-auto">
  <!-- Featured Announcement Box -->
  <div class="bg-white rounded-lg border border-gray-300 p-6 mb-6">
    <h2 class="text-2xl font-bold text-gray-900 mb-4">Kreismeisterschaft 2026</h2>
    <div class="flex flex-wrap gap-3">
      <a
        href="ausschreibungen/Anleitung_Meldeportal.pdf"
        target="_blank"
        class="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-full font-medium text-sm hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <svg class="w-4 h-4 mr-2" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
        </svg>
        Anleitung Meldeportal
      </a>
      <a
        href="https://meisterschaft.sko-sued.de/"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-full font-medium text-sm hover:bg-green-700 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
      >
        <svg class="w-4 h-4 mr-2" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
        </svg>
        Meldeportal
      </a>
      <a
        routerLink="/shooting-schedule"
        class="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-full font-medium text-sm hover:bg-purple-700 transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
      >
        <svg class="w-4 h-4 mr-2" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
        </svg>
        Standaufsichten
      </a>
      <a
        routerLink="/competition-dates"
        class="inline-flex items-center px-4 py-2 bg-orange-600 text-white rounded-full font-medium text-sm hover:bg-orange-700 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
      >
        <svg class="w-4 h-4 mr-2" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
        </svg>
        Wettbewerbe
      </a>
    </div>
  </div>

  <!-- News Section -->
  <div class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-2xl font-bold text-slate-800 mb-6 pb-3 border-b-2 border-slate-600">
      Aktuelles
    </h2>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="text-center py-8">
        <p class="text-slate-600">Lade Nachrichten...</p>
      </div>
    }

    <!-- Error State -->
    @if (error) {
      <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
        {{ error }}
      </div>
    }

    <!-- News Items -->
    @if (!isLoading && !error) {
      <div class="space-y-4">
        @for (item of newsItems; track $index) {
          <div class="border-l-4 border-slate-600 pl-4 py-2 hover:bg-slate-50 transition-colors">
            <p class="text-sm text-slate-500 mb-1">{{ item.Headline }}</p>
            @if (item.TextContent) {
              <p class="text-slate-800">{{ item.TextContent }}</p>
            }
            @if (item.HtmlTextContent) {
              <div class="text-slate-800" [innerHTML]="getSafeHtml(item.HtmlTextContent)"></div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
